export default __webpack_public_path__ + "static/media/roomsyncBlankAvatar_1.c7a72d80.png";